var _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCameraIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.41635 5.96167C2.41635 5.3107 2.86848 4.74707 3.50395 4.60586L5.30255 4.20617C5.4571 4.17183 5.59527 4.08571 5.69417 3.96208L6.51323 2.93825C6.77681 2.60878 7.17585 2.41699 7.59777 2.41699H9.73493C10.1568 2.41699 10.5559 2.60878 10.8195 2.93825L11.6385 3.96208C11.7374 4.08571 11.8756 4.17183 12.0302 4.20617L13.8288 4.60586C14.4642 4.74708 14.9164 5.3107 14.9164 5.96167V12.8337C14.9164 13.6007 14.2945 14.2225 13.5275 14.2225H3.80524C3.03818 14.2225 2.41635 13.6007 2.41635 12.8337V5.96167Z",
    stroke: "white",
    strokeWidth: 1.38889,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.66624,
    cy: 9.01411,
    r: 2.77778,
    stroke: "white",
    strokeWidth: 1.38889,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/camera-icon.67cb2bf19ff4cd532dcb059da03ccbc0.svg";
export { ForwardRef as ReactComponent };